import { render, staticRenderFns } from "./TPRAlignmentAlertModal.vue?vue&type=template&id=6486eace&"
import script from "./TPRAlignmentAlertModal.vue?vue&type=script&lang=js&"
export * from "./TPRAlignmentAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./TPRAlignmentAlertModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardTitle,VContainer,VDataTable,VDialog,VDivider,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3892323605/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6486eace')) {
      api.createRecord('6486eace', component.options)
    } else {
      api.reload('6486eace', component.options)
    }
    module.hot.accept("./TPRAlignmentAlertModal.vue?vue&type=template&id=6486eace&", function () {
      api.rerender('6486eace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TPRAlignmentAlertModal.vue"
export default component.exports